import produce from "immer";
import { schema } from "normalizr";
import set from "lodash/set";
import get from "lodash/get";
import isEmpty from "lodash/isEmpty";

import { validateShowHide3 } from "common3";

// import get from 'lodash/get'
import {
  LOAD_FORM3,
  LOAD_FORM3_SUCCESS,
  LOAD_FORM3_FAIL,
  SET_FORM3_SECTION,
  VALIDATION_ERROR,
  SAVE_FORM3,
  ADD_NOTE3,
  FORM_CLOSE3,
  UNLOAD_FORM3,
  SET_VALIDATION_MESSAGE3,
  CONFIRM_VALIDATION_MESSAGE3,
  STOP3,
  INC_FORM3_SECTION,
  LOAD_VIEW3,
  RUN_EFFECT_V3_SUCCESS,
  PUBSUB3_FORMDATA_UPDATE,
  RESET_ZEROID,
} from "../constants";

// import _validateShowHide3 from './_validateShowHide3'
// import { isNull } from "lodash";

const viewNodeSchema = new schema.Entity(
  "viewNodes",
  {},
  { idAttribute: "_id" }
);
viewNodeSchema.define({ structure: [viewNodeSchema] });

const initialState = {
  loading: false,
  rootId: null,
  nodes: null,
  allNodes: null,
  formData: {},
  activeSection: 0,
  connections: [],
  state: null,
  validations: {},
  validationResults: {},
  validationMessage: null,
  closed: false,
  stop: {},
  attachments: [],
  error: null,
  zeroListId: {},
};

const filterNodes = ({ formData, nodes, nodeId, context, zeroListId }) => {
  const node = nodes[nodeId];

  if (!node) {
    console.error(
      "[portal/src/reducers/form3.js]: NO NODE FOUND! SHOULD NOT HAPPEN"
    );
    return false;
  }

  const { extra = {} } = node;
  const { showHide = {}, disableRule = {} } = extra;

  const { reset } = showHide;

  // check for children
  if (node.structure) {
    // 2021-05: this was reversed. We do not know why but it caused chained showHide not to work
    // 2021-05 WAS:for (let i = node.structure.length - 1; i >= 0; i--) {
    for (let i = 0; i < node.structure.length; i++) {
      const childId = node.structure[i];
      filterNodes({ formData, nodes, nodeId: childId, context, zeroListId });
    }
  }

  if (
    extra.showHide &&
    !validateShowHide3({
      node,
      nodes,
      context: { ...context, formData },
      clientSide: true,
    })
  ) {
    // if ((extra.showHide && !_validateShowHide3({ conditions: clientConditions, formData, nodes,node, context }))) {
    nodes[nodeId].hideComponent = true;
    if (reset) {
      if (formData[nodeId]) {
        zeroListId[nodeId] = true;
        delete formData[nodeId];
      }
    }
    return false;
  }

  const { clientConditions: disableClientConditions } = disableRule;

  if (
    extra.disableRule &&
    !isEmpty(disableClientConditions) &&
    !validateShowHide3({
      node,
      nodes,
      context: { ...context, formData },
      clientSide: true,
      extraField: "disableRule",
    })
  ) {
    nodes[nodeId].disableComponent = true;
  } else {
    nodes[nodeId].disableComponent = false;
  }

  // bottom of tree
  nodes[nodeId].hideComponent = false;
  return true;
};

/**
 * Small helper function to ensure that we have the correct structure for *notes* and *markers*
 *
 * @param {*} draft - the immer draft objeckt to modify
 * @param {*} baseName  - note or marker
 * @param {*} type - internal or external
 * @param {*} emptyObject - the new object to create, [] for array or {} for object
 */
const _verifyInternalExternal = (draft, baseName, type, emptyObject) => {
  if (!draft.formData[baseName]) {
    draft.formData[baseName] = {};
  }

  if (!draft.formData[baseName][type]) {
    draft.formData[baseName][type] = emptyObject;
  }

  // if( draft.formData)
};

const form3Reducer = produce((draft, action, state) => {
  switch (action.type) {
    case LOAD_VIEW3: {
      const { queryParams = {} } = action;
      if (queryParams.formDataId || queryParams.formId) {
        let activeSection = 0;
        if (queryParams.formDataId) {
          activeSection = localStorage.getItem("activeSectionIndex");
        }

        return {
          ...initialState,
          activeSection: activeSection ? activeSection : 0,
        };
      }
      break;
    }
    case LOAD_FORM3:
      draft.loading = true;
      draft.closed = false;
      draft.activeSection = action.activeSectionIndex;
      break;
    case LOAD_FORM3_SUCCESS: {
      draft.loading = false;
      draft.nodes = action.nodes;
      // draft.allNodes = action.nodes;
      draft.rootId = action.rootId;
      draft.templateId = action.templateId;
      draft.formData = action.formData;
      draft.connections = action.connections;
      draft.validations = action.validations;
      draft.state = action.state;
      draft.attachments = action.attachments;
      draft.formProcess = action.formProcess;

      filterNodes({
        formData: draft.formData,
        zeroListId: draft.zeroListId,
        nodeId: draft.rootId,
        nodes: draft.nodes,
        context: {
          effects: {
            ...state.effect3.effects,
            [action.effectId]: action.data,
          },
          user: state.user3.user,
        },
      });
      break;
    }
    case LOAD_FORM3_FAIL: {
      draft.error = action.err;
      break;
    }

    case UNLOAD_FORM3: {
      return initialState;
    }

    case SET_FORM3_SECTION: {
      // this might be a big no-no. But it works
      localStorage.setItem("activeSectionIndex", action.index);
      draft.activeSection = action.index;
      break;
    }

    case INC_FORM3_SECTION: {
      draft.activeSection++;
      break;
    }

    case PUBSUB3_FORMDATA_UPDATE:
      // ensure that we have a form loaded, otherwise things will crash
      if (!draft.nodes) {
        return;
      }
    // NO break! This is intentional as PUBSUB3_FORMDATA_UPDATE goes into SAVE_FORM3
    // eslint-disable-next-line
    case SAVE_FORM3: {
      set(draft, `formData.${action.key}`, action.value);

      const nameProp = get(draft, `nodes[${action.key}].extra.name`, null);

      if (nameProp) {
        set(draft, `formData.${nameProp}`, action.value);
      }

      filterNodes({
        formData: draft.formData,
        zeroListId: draft.zeroListId,
        nodeId: draft.rootId,
        nodes: draft.nodes,
        context: {
          effects: {
            ...state.effect3.effects,
            [action.effectId]: action.data,
          },
          user: state.user3.user,
        },
      });

      // draft.nodes = newNodes
      break;
    }

    case RUN_EFFECT_V3_SUCCESS: {
      // const _effects =
      if (draft.nodes) {
        filterNodes({
          formData: draft.formData,
          zeroListId: draft.zeroListId,
          nodeId: draft.rootId,
          nodes: draft.nodes,
          context: {
            effects: {
              ...state.effect3.effects,
              [action.effectId]: action.data,
            },
            user: state.user3.user,
          },
        });
      }
      break;
    }

    case VALIDATION_ERROR: {
      /**
       * Note support for both Arrays and objects
       *
       * Arrays is for section and form validation and will REPLACE the validation
       * Objects are for single field validation and will set/remove ONE validation and KEEP the others
       */
      if (Array.isArray(action.results)) {
        // this redcue converts the incoming results to the reducer-result (and object with keys)
        draft.validationResults = action.results.reduce((acc, cur) => {
          acc[cur.key] = cur.results;
          return acc;
        }, {});
      } else {
        if (action.results) {
          draft.validationResults[action.key] = action.results;
        } else {
          delete draft.validationResults[action.key];
        }
      }
      break;
    }
    case CONFIRM_VALIDATION_MESSAGE3: {
      draft.validationMessage = null;
      break;
    }
    case SET_VALIDATION_MESSAGE3: {
      draft.validationMessage = action.payload;
      break;
    }
    case ADD_NOTE3: {
      _verifyInternalExternal(draft, "notes", "external", []);

      if (action.noteType !== "internal" && action.noteType !== "external") {
        return;
      }

      // ensure that we do not add same not twice
      let found = false;

      draft.formData.notes[action.noteType].forEach((n) => {
        if (n.noteId === action.noteId) {
          found = true;
        }
      });

      if (found) {
        break;
      }

      draft.formData.notes["external"].push({
        origin: action.origin ? action.origin : "portal",
        note: action.note,
        noteId: action.noteId,
        assetId: action.assetId,
      });
      break;
    }
    case FORM_CLOSE3: {
      draft.closed = true;
      draft.loading = false;
      draft.connections = [];
      break;
    }

    case STOP3: {
      draft.stop = action.stop;
      break;
    }

    case RESET_ZEROID: {
      draft.zeroListId = {};
      //delete draft.zeroListId[action.id];
      break;
    }

    default:
      break;
  }
}, initialState);

export default form3Reducer;

/* Getters */

export const getForm3Loading = (state) => {
  return state.loading;
};
export const getForm3Nodes = (state) => {
  return state.nodes;
};

export const getForm3State = (state) => {
  return state.state;
};

export const getForm3Id = (state) => {
  return state.rootId;
};

export const getForm3TemplateId = (state) => {
  return state.templateId;
};

export const getForm3ActiveSection = (state) => {
  return state.activeSection;
};

export const getForm3Data = (state) => {
  return state.formData;
};

export const getForm3Connections = (state) => {
  return state.connections;
};

export const getForm3Validations = (state) => {
  return state.validations;
};

export const getForm3ValidationErrors = (state) => {
  return state.validationResults;
};

export const getForm3Closed = (state) => {
  return state.closed;
};

export const getForm3ValidationMessage = (state) => {
  return state.validationMessage;
};

export const getForm3Stop = (state) => {
  return state.stop;
};

export const getForm3Error = (state) => {
  return state.error;
};

export const getForm3Process = (state) => {
  return state.formProcess;
};

export const getForm3Attachments = (state) => {
  return state.attachments;
};

export const getZeroIds = (state) => {
  return state.zeroListId;
};
